import iframeResize from 'iframe-resizer/js/iframeResizer';

iframeResize();
